<div class="forgot-password-outer-container">
  <div class="forgot-password-container">

    <h2>{{ 'forgotPassword.title' | translate }}</h2>

    <ng-container *ngIf="!emailSent else emailSentText">

      <p>{{ 'forgotPassword.text' | translate }}</p>

      <mat-form-field>
        <input [disabled]="busy" type="email" matInput [(ngModel)]="email" placeholder="{{ 'forgotPassword.emailAddress' | translate }}">
      </mat-form-field>

      <div class="error-container" *ngIf="errorMessage">
        <span *ngIf="errorCode" class="error-code">{{ errorCode }}</span>: {{ errorMessage }}
      </div>

      <button [disabled]="busy" type="submit" mat-flat-button color="primary" (click)="resetPassword()">{{ 'forgotPassword.reset' | translate }}</button>
    </ng-container>

    <ng-template #emailSentText>
      <p>{{ 'forgotPassword.emailSent' | translate }}</p>
    </ng-template>

    <div class="back-to-login-container">
      <button mat-flat-button (click)="goBackToLogin()">{{ 'forgotPassword.backToLogin' | translate }}</button>
    </div>

  </div>
</div>
